import adminApiClient from '../../api/base/adminApiClient'

export interface Notice {
  id: number
  title: string
  content: string
  created_at: string
  updated_at: string
}

export interface GetNoticesResponse {
  data: Notice[]
  current_page: number
  last_page: number
  per_page: number
  total: number
}

export interface GetNoticesParams {
  page?: number
  per_page?: number
  search?: string
}

export interface CreateNoticeRequest {
  title: string
  content: string
}

export interface CreateNoticeResponse {
  message: string
  data: Notice
}

export interface UpdateNoticeRequest {
  title: string
  content: string
}

export interface UpdateNoticeResponse {
  message: string
  data: Notice
}

export interface DeleteNoticeResponse {
  message: string
}

export const adminNoticeApi = {
  getNotices: async (
    params?: GetNoticesParams
  ): Promise<GetNoticesResponse> => {
    const response = await adminApiClient.get<GetNoticesResponse>(
      '/admin/notices',
      {
        params,
      }
    )
    return response.data
  },

  createNotice: async (
    data: CreateNoticeRequest
  ): Promise<CreateNoticeResponse> => {
    const response = await adminApiClient.post<CreateNoticeResponse>(
      '/admin/notices',
      data
    )
    return response.data
  },

  updateNotice: async (
    id: number,
    data: UpdateNoticeRequest
  ): Promise<UpdateNoticeResponse> => {
    const response = await adminApiClient.put<UpdateNoticeResponse>(
      `/admin/notices/${id}`,
      data
    )
    return response.data
  },

  deleteNotice: async (id: number): Promise<DeleteNoticeResponse> => {
    const response = await adminApiClient.delete<DeleteNoticeResponse>(
      `/admin/notices/${id}`
    )
    return response.data
  },
}
